/* eslint-disable default-case */
import React, { useEffect, useState, useMemo } from "react";
import { CustomTable } from "../../components/Table";
import Articleform from "../../components/forms/JournalOverviewForm";
import "@fortawesome/fontawesome-free/css/all.min.css";
import PTSCard from "../../components/ui/Model";
import { FaSearch, FaTimes } from "react-icons/fa";
import NoData from "../../assets/article.png";
import {
  fetchArticleByJournal,
  updateJournalArticle,
  fetchVolIss,
} from "../../services/apiService/articleApi";
import { useSelector } from "react-redux";
import useToaster from "../../hooks/useToaster";
import Pencils from "../../assets/pencil.png";
import { fetchUserForForm } from "../../services/apiService/userApi";
import { Popover, PopoverTrigger } from "../../components/ui/Popover";
import DropdownCheckbox from "../../components/ui/DropdownCheck";
import { MdOutlineFilterAlt } from "react-icons/md";
import { FaArrowLeft } from "react-icons/fa";
import Pagination from "../../components/ui/Pagination";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import DynamicFilterPopover from "../../components/ui/DynamicFilterPopover";
import FilterChips from "../../components/ui/FilterChip";
import { useRef } from "react";
import { Spinner } from "../../components/ui/Skeleton";
import { ArticleHeaders } from "../../lib/utils";
import DataSyncError from "../../components/edgeCases/DataSyncError";

// import JournalPopover from "../../components/ui/DropdownSingle";

const Article = ({ onBack, journal, config }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedArticle, setSelectedArticle] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [isModelOpen, setIsModelOpen] = useState(false);
  const [isFocused, setIsFocused] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [articles, setArticles] = useState([]);
  const [fullArticles, setFullArticles] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [productionHandlersForFilter, setProductionHandlersForFilter] =
    useState([]);
  const [productionHandlersForForm, setProductionHandlersForForm] = useState(
    []
  );
  const [fieldConfiguration, setFieldConfiguration] = useState(null);
  const [selectedVolIssues, setSelectedVolIssues] = useState(["All"]);
  const [selectedJournals, setSelectedJournals] = useState(null);
  //const [selectedJournalId, setSelectedJournalId] = useState([]);
  const [selectedProductionHandlers, setSelectedProductionHandlers] = useState([
    "All",
  ]);
  const [selectedProductionHandlersId, setSelectedProductionHandlersId] =
    useState(["All"]);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [tempArticleTypes, setTempArticleTypes] = useState([]);

  const [selectedArticleTypes, setSelectedArticleTypes] = useState([]);
  const [activeRowId, setActiveRowId] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(100);
  const [totalItems, setTotalItems] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  // Add this with your other state declarations
  const [articleTypeOpen, setArticleTypeOpen] = useState(false);
  const [showFilterPopover, setShowFilterPopover] = useState(false);
  const showToast = useToaster();
  const { userData, dataSyncTime } = useSelector((state) => state.user);
  let [hasFilters, setHasFilters] = useState(false);
  let [headers, setHeaders] = useState([]);
  let [columnName, setColumnName] = useState("");

  let [articleCount, setArticleCount] = useState(0);

  let [sortConfig, setSortConfig] = useState({ key: "pts", direction: "asc" });

  let [volIssOptions, setVolIssOptions] = useState([]);

  let [articleTypesOptions, setArticleTypesOptions] = useState([]);
  //   let [productionHandlerFromFetch, setProductionHandlersFromFetch] = useState([])

  let [productionWorkflowOptions, setProductionWorkflowOptions] = useState([]);
  let [pitOptions, setPitOptions] = useState([]);
  let [docHeadOptions, setDocHeadOptions] = useState([]);

  const [productionWorkflowOpen, setProductionWorkflowOpen] = useState(false);
  let [pitOpen, setPitOpen] = useState(false);
  let [docHeadOpen, setDocHeadOpen] = useState(false);

  const [tempCopyediting, setTempCopyediting] = useState(["All"]);
  const [selectedCopyediting, setSelectedCopyediting] = useState(["All"]);

  let [tempPit, setTempPit] = useState(["All"]);
  let [pit, setPit] = useState(["All"]);

  let [tempDocHead, setTempDocHead] = useState(["All"]);
  let [docHead, setDocHead] = useState(["All"]);

  let [tempSceReturned, setTempSceReturned] = useState("");
  let [sceReturned, setSceReturned] = useState("");

  let [tempPressRelease, setTempPressRelease] = useState("");
  let [pressRelease, setPressRelease] = useState("");

  let [tempArticleS300Date, setTempArticleS300Date] = useState("");
  let [articleS300Date, setArticleS300Date] = useState("");

  let [tempCopyEditTaskComplete, setTempCopyEditTaskComplete] = useState("");
  let [copyEditTaskComplete, setCopyEditTaskComplete] = useState("");

  let [tempCfcTaskComplete, setTempCfcTaskComplete] = useState("");
  let [cfcTaskComplete, setCfcTaskComplete] = useState("");

  let [tempCoverSubReceived, setTempCoverSubReceived] = useState("");
  let [coverSubReceived, setCoverSubReceived] = useState("");

  let [tempPreAcceptDate, setTempPreAcceptDate] = useState(false);
  let [tempsdPublishedOnWebS300, setTempsdPublishedOnWebS300] = useState(false);

  let [preAcceptDate, setPreAcceptDate] = useState(false);
  let [sdPublishedOnWebS300, setSdPublishedOnWebS300] = useState(false);

  let [tempOnDate, setTempOnDate] = useState({ from: "", to: "" });
  let [onDate, setOnDate] = useState({ from: "", to: "" });

  const [hasChanged, setHasChanged] = useState(false);
  const [initialSelectedRow, setInitialSelectedRow] = useState(null);
  const searchTriggeredRef = useRef(false);
  const sortEffectRanRef = useRef(false);

  let FirstEffectRanRef = useRef(false);

  //   let [hasSections, setHasSections] = useEffect(false);

  /**
   * Finds headers from config and places "PTS#" at the top of the list
   */
  let findHeaders = () => {
    const header = config
      ?.map((jnl) => {
        if (
          (jnl.articleOrIssue === "both" || jnl.articleOrIssue === "article") &&
          jnl.showField
        ) {
          const match = ArticleHeaders.find((ah) => ah.key === jnl.key);

          return {
            key:
              jnl.key === "productionHandler"
                ? "productionHandlerName"
                : jnl.key,
            value: match
              ? match.value
              : jnl.key === "productionHandler"
              ? "PROD HAND"
              : jnl.property.toUpperCase(),
          };
        }
      })
      .filter(Boolean);

    const journalHeader = header.find((h) =>
      h.key.toLowerCase().includes("journal")
    );
    const ptsHeader = header.find((h) => h.value === "PTS#");

    const otherHeaders = header.filter(
      (h) => h !== journalHeader && h !== ptsHeader
    );

    const orderedHeaders = [];
    if (journalHeader) orderedHeaders.push(journalHeader);
    if (ptsHeader) orderedHeaders.push(ptsHeader);
    orderedHeaders.push(...otherHeaders);

    setHeaders(orderedHeaders);
  };

  //const headers = ArticleHeaders;

  useEffect(() => {
    findHeaders();
    if (userData && userData.articleOverview === "Edit") {
      setIsEdit(true);
    }
  }, []);

  useEffect(() => {
    if (!headers.length) {
      setArticles([]);
      setTotalItems(0);
      setTotalPages(0);
    }
  }, [headers]);

  let hasChangesArray = ["issue", "volume"];

  /**
   * Fetches articles data from API with pagination
   * @async
   * @function fetchArticlesData
   * @returns {Promise<void>}
   */
  const fetchArticlesData = async () => {
    setIsLoading(true);
    try {
      const response = await fetchArticleByJournal(journal.id, {
        page: selectedProductionHandlers[0] !== "All" ? 1 : currentPage,
        limit: itemsPerPage,
        search: searchTerm.trim(),
        volIss: selectedVolIssues,
        productionHandler:
          selectedProductionHandlersId[0] !== "All" &&
          selectedProductionHandlersId.length !==
            productionHandlerOptions.length
            ? selectedProductionHandlersId.map((art) => art.value)
            : ["All"],
        key: sortConfig.key,
        direction: sortConfig.direction,
        id: userData.id,
        copyedit: selectedCopyediting,
        docHead: docHead,
        pit: pit,
        sceReturned: sceReturned,
        pressRelease: pressRelease,
        articleS300Date: articleS300Date,
        copyEditTaskComplete: copyEditTaskComplete,
        cfcTaskComplete: cfcTaskComplete,
        coverSubReceived: coverSubReceived,
        preAcceptDate: preAcceptDate,
        sdPublishedOnWebS300: sdPublishedOnWebS300,
        onDate: onDate,
      });
      sortEffectRanRef.current = true;
      if (response.success && response?.data && response?.data?.data) {
        setFullArticles(response?.data?.data);

        const articlesWithVolIss = response.data.data.map((article) => {
          return {
            ...article,
            hasChanges:
              Array.isArray(article.changes) &&
              article.changes.some(
                (change) =>
                  change.key &&
                  change.previousValue !== null &&
                  change.previousValue !== 0 &&
                  hasChangesArray.includes(change.key)
              ),
            type: "Article",
          };
        });

        setArticles(articlesWithVolIss);
        setTotalItems(response.data.pagination.totalItems);
        setTotalPages(response.data.pagination.totalPages);
        setArticleCount(response.data.pagination.totalItems);
      } else {
        setArticles([]);
        setTotalItems(0);
        setTotalPages(0);
        setArticleCount(0);
      }
    } catch (error) {
      setArticles([]);
      setTotalItems(0);
      setTotalPages(0);
      showToast("Failed to load articles. Please try again later.");
      console.log(error);
      setArticleCount(0);
    } finally {
      setIsLoading(false);
      FirstEffectRanRef.current = true;
    }
  };

  useEffect(() => {
    if (!headers.length) return;
    fetchArticlesData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    currentPage,
    itemsPerPage,
    selectedJournals,
    selectedArticleTypes,
    selectedCopyediting,
    selectedVolIssues,
    selectedProductionHandlersId,
    selectedProductionHandlers,
    sortConfig,
    headers,
    sceReturned,
    pressRelease,
    articleS300Date,
    pit,
    docHead,
    copyEditTaskComplete,
    cfcTaskComplete,
    coverSubReceived,
    onDate,
    preAcceptDate,
    sdPublishedOnWebS300,
  ]);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (!searchTriggeredRef.current) return;
      if (searchTerm.trim().length > 2 || !searchTerm.trim()) {
        fetchArticlesData();
      }
    }, 600);

    return () => clearTimeout(timeoutId);
  }, [searchTerm]);

  const fetchProductionHandlers = async (productionHandlers = []) => {
    try {
      const response = await fetchUserForForm();
      if (response.success) {
        const handlersForForm = response.data.userOptions;

        let handlersForFilter = handlersForForm.filter((handler) =>
          productionHandlers?.some((val) => val.value === handler.value)
        );

        handlersForFilter.push({ label: "Null", value: "empty" });

        setProductionHandlersForFilter(handlersForFilter);
        setProductionHandlersForForm(handlersForForm);
      } else {
        showToast(response.message || "Error fetching production handlers");
        setProductionHandlersForFilter([]);
        setProductionHandlersForForm([]);
      }
    } catch (error) {
      showToast("Failed to load production handlers");
    }
  };

  const fetchJournalConfiguration = async (journalId) => {
    try {
      let response = fullArticles.filter(
        (article) => article.journalId.toLowerCase() === journalId.toLowerCase()
      );
      setFieldConfiguration(
        response?.[0]?.fieldConfiguration || response?.fieldConfiguration || []
      );
    } catch (error) {
      console.error("Error fetching journal configuration:", error);
      showToast("Failed to load journal configuration");
    }
  };

  let fetchVolIssOptions = async () => {
    try {
      let response = await fetchVolIss({
        id: userData.id,
        type: "Article",
        time: "",
        journal: journal.id,
        place: "articleOverview",
      });
      setVolIssOptions(response.data.data.volIss);
      setProductionWorkflowOptions(response?.data?.data?.productionWorkflow);
      setArticleTypesOptions(response?.data?.data?.docHead);
      //   setProductionHandlersFromFetch()
      fetchProductionHandlers(response?.data?.data?.productionHandlers);
      setPitOptions(response?.data?.data?.pit);
      setDocHeadOptions(response?.data?.data?.docHead);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchVolIssOptions();
    // fetchProductionHandlers();
  }, []);

  // Handle page change
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  // Handle items per page change
  const handleItemsPerPageChange = (size) => {
    setItemsPerPage(size);
    setCurrentPage(1); // Reset to first page when changing items per page
  };

  const toggleDropdown = (dropdownName) => {
    setOpenDropdown(openDropdown === dropdownName ? null : dropdownName);
  };

  const closeAllDropdowns = () => {
    setOpenDropdown(null);
  };

  const handleArticleClick = async (article) => {
    setSelectedArticle(article);
    if (article.journalId) {
      await fetchJournalConfiguration(article.journalId);
    }
    setShowForm(true);
  };

  const productionHandlerOptions = useMemo(() => {
    return productionHandlersForFilter;
  }, [productionHandlersForFilter]);

  const handleVolIssueSelection = (selected) => {
    if (selected.includes("All") || selected.length === 0) {
      setSelectedVolIssues(["All"]);
    } else {
      setSelectedVolIssues(selected);
    }
    closeAllDropdowns();
  };

  const handleJournalSelection = (selected) => {
    setSelectedJournals(selected === null ? null : selected);
    closeAllDropdowns();
  };

  const handleProductionHandlerSelection = (selected, selectedId) => {
    if (
      selected.includes("All") ||
      selected.length === 0 ||
      selected.length === productionHandlerOptions.length
    ) {
      setSelectedProductionHandlers(["All"]);
      setSelectedProductionHandlersId(["All"]);
    } else {
      setSelectedProductionHandlers(selected);
      setSelectedProductionHandlersId(selectedId);
    }
    closeAllDropdowns();
  };

  const handleTempDocHead = (doc) => {
    setTempDocHead(doc.length >= 1 ? doc : ["All"]);
  };

  const handleTempArticleS300Date = (val) => {
    setTempArticleS300Date(tempArticleS300Date === val ? "" : val);
  };

  const handleTempPit = (pit) => {
    setTempPit(pit.length >= 1 ? pit : ["All"]);
  };

  const handleTempCopyeditingChange = (copyediting) => {
    setTempCopyediting(copyediting.length >= 1 ? copyediting : ["All"]);
  };

  const handleTempSceReturnedStatus = (val) => {
    setTempSceReturned(tempSceReturned === val ? "" : val);
  };

  const handleTempPressRelease = (val) => {
    setTempPressRelease(tempPressRelease === val ? "" : val);
  };

  const handleTempCopyEditTaskComplete = (val) => {
    setTempCopyEditTaskComplete(tempCopyEditTaskComplete === val ? "" : val);
  };

  const handleTempCfcTaskComplete = (val) => {
    setTempCfcTaskComplete(tempCfcTaskComplete === val ? "" : val);
  };

  const handleTempCoverSubReceived = (val) => {
    setTempCoverSubReceived(tempCoverSubReceived === val ? "" : val);
  };

  const handleTempPreAcceptDate = (val) => {
    setTempPreAcceptDate(tempPreAcceptDate === val ? "" : val);
  };
  const handleTempsdPublishedOnWebS300 = (val) => {
    setTempsdPublishedOnWebS300(tempsdPublishedOnWebS300 === val ? "" : val);
  };

  const handleTempOnDate = (key, val) => {
    if (key === "to" && tempOnDate.from > val) {
      return;
    }
    setTempOnDate((prev) => ({ ...prev, [key]: val }));
  };

  const applyFilters = () => {
    setSelectedCopyediting(tempCopyediting);
    setPit(tempPit);
    setDocHead(tempDocHead);

    setSceReturned(tempSceReturned);
    setPressRelease(tempPressRelease);
    setCoverSubReceived(tempCoverSubReceived);
    setPreAcceptDate(tempPreAcceptDate);
    setSdPublishedOnWebS300(tempsdPublishedOnWebS300);
    setCfcTaskComplete(tempCfcTaskComplete);
    setCopyEditTaskComplete(tempCopyEditTaskComplete);
    setArticleS300Date(tempArticleS300Date);

    setOnDate(tempOnDate);
    closeAllDropdowns();
    setCurrentPage(1);
  };

  const clearAllFilters = () => {
    setSelectedVolIssues(["All"]);
    setSelectedJournals(null);
    setSelectedProductionHandlers(["All"]);
    setSelectedProductionHandlersId(["All"]);
    setTempCopyediting(["All"]);
    setSelectedCopyediting(["All"]);
    setTempPit(["All"]);
    setPit(["All"]);
    setTempDocHead(["All"]);
    setDocHead(["All"]);
    setTempSceReturned("");
    setSceReturned("");
    setTempPressRelease("");
    setPressRelease("");
    setTempCoverSubReceived("");
    setCoverSubReceived("");
    setTempPreAcceptDate(false);
    setTempsdPublishedOnWebS300(false);
    setPreAcceptDate(false);
    setSdPublishedOnWebS300(false);
    setTempCfcTaskComplete("");
    setCfcTaskComplete("");
    setTempCopyEditTaskComplete("");
    setCopyEditTaskComplete("");
    setTempArticleS300Date("");
    setArticleS300Date("");
    setTempOnDate({ from: "", to: "" });
    setOnDate({ from: "", to: "" });
    setHasFilters(false);
    setCurrentPage(1);
  };

  let handleAdvancedClear = () => {
    setTempCopyediting(["All"]);
    setTempDocHead(["All"]);
    setTempPit(["All"]);

    setTempSceReturned("");
    setTempPressRelease("");
    setTempCoverSubReceived("");
    setTempPreAcceptDate(false);
    setTempsdPublishedOnWebS300(false);
    setTempCfcTaskComplete("");
    setTempCopyEditTaskComplete("");
    setTempArticleS300Date("");

    setTempOnDate({ from: "", to: "" });
  };

  useEffect(() => {
    if (openDropdown === "filter") {
      setTempCopyediting(selectedCopyediting);
      setTempPit(pit);
      setTempDocHead(docHead);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    articleS300Date,
    cfcTaskComplete,
    copyEditTaskComplete,
    coverSubReceived,
    preAcceptDate,
    sdPublishedOnWebS300,
    docHead,
    onDate,
    pit,
    pressRelease,
    sceReturned,
    selectedCopyediting,
    openDropdown,
  ]);

  const action = (row) => {
    const isEditable = userData?.articleOverview?.toLowerCase() === "edit";
    return (
      <img
        src={Pencils}
        alt="Edit"
        className={`max-w-8 min-w-4 max-h-8 min-h-4 px-2 py-2 rounded-md ${
          isEditable
            ? "hover:bg-[#B8C7FE] cursor-pointer"
            : "opacity-50 cursor-not-allowed"
        }`}
        onClick={isEditable ? () => handleArticleClick(row) : null}
      />
    );
  };

  let HandleUpdateData = async (updatedData) => {
    try {
      const {
        journalInfo,
        volIssue,
        hasChanges,
        copyediting,
        team,
        ...dataToUpdate
      } = updatedData;

      if (typeof dataToUpdate.points === "string") {
        const parsed = Number(dataToUpdate.points);
        dataToUpdate.points = isNaN(parsed) ? null : parsed;
      }

      const response = await updateJournalArticle(updatedData.id, dataToUpdate);
      if (response?.success) {
        await fetchArticlesData();
        showToast("Article updated successfully");
        setShowForm(false);
        setIsModelOpen(false);
      } else {
        showToast(response?.message || "Failed to update article");
      }
      setActiveRowId(null);
      setIsModelOpen(false);
      await fetchVolIssOptions();
    } catch (error) {
      showToast(error.message || "Error updating article");
    }
  };

  let RowSelected = async (selectedData, columnName) => {
    setSelectedRow(selectedData);
    setInitialSelectedRow(selectedData); // Store initial data
    setHasChanged(false); // Reset hasChanged
    let newName =
      columnName === "productionHandlerName" ? "productionHandler" : columnName;
    setColumnName(newName);
    let Field = config.find((field) => field.key === newName);
    if (selectedData.journalId) {
      await fetchJournalConfiguration(selectedData.journalId);
    }
    if (Field.manualOverwrite) {
      setIsModelOpen(true);
    }
  };

  useEffect(() => {
    if (
      selectedCopyediting.length > 0 &&
      !selectedCopyediting.includes("All")
    ) {
      setHasFilters(true);
    } else {
      setHasFilters(false);
    }
  }, [selectedArticleTypes, selectedCopyediting]);

  const findEditable = (name) => {
    const targetKey =
      name === "productionHandlerName" ? "productionHandler" : name;
    const field = config.find((field) => field.key === targetKey);
    return field?.manualOverwrite === true;
  };

  const ArticleSections = [
    {
      label: "Production workflow",
      key: "productionWorkflow",
      values: productionWorkflowOptions,
    },
    {
      label: "PIT",
      key: "pit",
      values: pitOptions,
    },
    {
      label: "Dochead",
      key: "docHead",
      values: docHeadOptions,
    },

    {
      label: "SCE returned status",
      key: "sceReturnedStatus",
      values: [
        { value: true, label: "Yes" },
        { value: false, label: "No" },
      ],
    },
    {
      label: "Press release?",
      key: "pressRelease",
      values: [
        { value: true, label: "Yes" },
        { value: false, label: "No" },
      ],
    },
    {
      label: "ON date",
      key: "onDate",
    },
    {
      label: "Article S300 date",
      key: "articleS300Date",
      values: [
        { value: true, label: "Yes" },
        { value: false, label: "No" },
      ],
    },
    {
      label: "Copy edit task complete",
      key: "copyEditTaskComplete",
      values: [
        { value: true, label: "Yes" },
        { value: false, label: "No" },
      ],
    },
    {
      label: "CFC task complete",
      key: "cfcTaskComplete",
      values: [
        { value: true, label: "Yes" },
        { value: false, label: "No" },
      ],
    },
    {
      label: "Cover sub received",
      key: "coverSubReceived",
      values: [
        { value: true, label: "Yes" },
        { value: false, label: "No" },
      ],
    },
    {
      label: "Include pre accepted",
      key: "preAcceptDate",
      values: [
        { value: true, label: "Yes" },
        { value: false, label: "No" },
      ],
    },
    {
      label: "Include published articles",
      key: "sdPublishedOnWebS300",
      values: [
        { value: true, label: "Yes" },
        { value: false, label: "No" },
      ],
    },
  ].filter((section) =>
    section.key === "sdPublishedOnWebS300" ||
    config?.some((c) => c?.key === section?.key && c?.showField)
    
  );

  useEffect(() => {
    // setHasSections(ArticleSections?.length > 1);
  }, [ArticleSections]);

  let articleSelected = {
    productionWorkflow: tempCopyediting,
    pit: tempPit,
    docHead: tempDocHead,
    sceReturnedStatus: tempSceReturned,
    pressRelease: tempPressRelease,
    articleS300Date: tempArticleS300Date,
    copyEditTaskComplete: tempCopyEditTaskComplete,
    cfcTaskComplete: tempCfcTaskComplete,
    coverSubReceived: tempCoverSubReceived,
    onDate: tempOnDate,
    preAcceptDate: tempPreAcceptDate,
    sdPublishedOnWebS300: tempsdPublishedOnWebS300,
  };

  let ArticleTempSetValues = {
    productionWorkflow: handleTempCopyeditingChange,
    pit: handleTempPit,
    docHead: handleTempDocHead,
    sceReturnedStatus: handleTempSceReturnedStatus,
    pressRelease: handleTempPressRelease,
    articleS300Date: handleTempArticleS300Date,
    copyEditTaskComplete: handleTempCopyEditTaskComplete,
    cfcTaskComplete: handleTempCfcTaskComplete,
    coverSubReceived: handleTempCoverSubReceived,
    preAcceptDate: handleTempPreAcceptDate,
    sdPublishedOnWebS300: handleTempsdPublishedOnWebS300,
    onDate: handleTempOnDate,
  };

  const normalizeValue = (value) => {
    if (value === null || value === undefined) return "";
    if (typeof value === "boolean") return value;
    if (typeof value === "string") {
      if (value.toLowerCase() === "true") return true;
      if (value.toLowerCase() === "false") return false;
      return value.trim();
    }
    if (typeof value === "number") return value;
    return String(value); // Convert other types to string
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setSelectedRow((prev) => {
      const updated = { ...prev, [name]: value };

      // Compare with initialSelectedRow
      const hasChanged = Object.keys(updated).some((key) => {
        return (
          normalizeValue(updated[key]) !==
          normalizeValue(initialSelectedRow?.[key])
        );
      });

      setHasChanged(hasChanged);
      return updated;
    });
  };

  if (isLoading && articles.length === 0) {
    return (
      <div className="flex items-center justify-center h-full">
        <Spinner />
      </div>
    );
  }

  return (
    <div
      className="flex flex-col"
      style={{ fontFamily: "Source Sans Pro", height: "calc(100vh - 80px)" }}
    >
      <div className="flex flex-1 flex-col h-full overflow-hidden">
        <div className="flex-1 bg-white flex flex-col h-full">
          <div className="header-section shrink-0 bg-white sticky top-0 z-10">
            <div className="flex items-center justify-start mb-1 space-x-1">
              <button onClick={onBack}>
                <p className="text-[#868E94] font-medium hover:underline text-[13px]">
                  Journal Overview
                </p>
              </button>{" "}
              <MdOutlineKeyboardArrowRight className="text-[#5D6871] text-[16px]" />{" "}
              <p className="text-[#5D6871] font-medium text-[13px]">
                {journal.journalName}
              </p>
            </div>

            <div className="flex items-center justify-between w-full py-2">
              <div className="flex items-center space-x-2">
                <button
                  onClick={onBack}
                  className="text-[#20282E] text-[20px] p-2"
                >
                  <FaArrowLeft />
                </button>
                <h1 className="text-[#20282E] text-[23px] font-semibold mb-0">
                  Article Overview {`(${articleCount})`}
                </h1>
              </div>

              <div className="text-[#35424D] text-[11px] h-[14px] w-[165px] font-medium ml-auto flex items-center">
                <DataSyncError />
                Last Sync: {dataSyncTime?.value}
                <br></br>
                {/* {dataSyncTime?.value ? "Snowflake data not available." : ""} */}
              </div>
            </div>

            <>
              <div className="flex items-center justify-between gap-4 mb-4">
                <div className="relative w-[246px]">
                  <input
                    type="text"
                    className={`border rounded-[4px] w-[246px] h-[32px] py-[4px] px-[12px] pr-[32px] text-sm transition-colors ${
                      isFocused
                        ? "focus:border-[#35424D] focus:border focus:outline-none"
                        : "border-[#C3C3C3]"
                    }`}
                    placeholder="Search"
                    maxLength={100}
                    value={searchTerm}
                    onChange={(e) => {
                      setSearchTerm(e.target.value);
                      searchTriggeredRef.current = true;
                    }}
                    onFocus={() => setIsFocused(true)}
                    onBlur={() => searchTerm === "" && setIsFocused(false)}
                  />
                  {(!isFocused || searchTerm.length === 0) && (
                    <FaSearch className="absolute right-3 top-1/2 transform -translate-y-1/2 text-[#C3C3C3]" />
                  )}
                  {searchTerm.length > 0 && isFocused && (
                    <FaTimes
                      className="absolute right-3 top-1/2 transform -translate-y-1/2 text-[#C3C3C3] cursor-pointer"
                      onClick={() => {
                        setSearchTerm("");
                        setIsLoading(true);
                      }}
                    />
                  )}
                </div>

                <div className="flex items-center gap-2">
                  {/* <Popover
                    open={openDropdown === "volIssue"}
                    onOpenChange={(open) => {
                      if (open) {
                        toggleDropdown("volIssue");
                      } else {
                        closeAllDropdowns();
                        // for remove temp selected options
                        setVolIssOptions((prev) => [...prev]);
                      }
                    }}
                  >
                    <PopoverTrigger asChild>
                      <button
                        className={`flex items-center gap-1 px-3 py-1 h-[32px] rounded-md hover:bg-[#EFF1F1] ${
                          openDropdown === "volIssue" ? "bg-[#D9D9D9]" : " "
                        }`}
                      >
                        <span className="text-[#35424D] text-[13px]">
                          <span className="font-semibold">Vol/Iss:</span>{" "}
                          <span className="font-medium">
                            {selectedVolIssues.includes("All")
                              ? "All"
                              : `${selectedVolIssues[0]}${
                                  selectedVolIssues.length > 1 ? " + more" : ""
                                }`}
                          </span>
                        </span>
                        <i
                          className={`fas fa-chevron-down text-[#35424D] text-xs`}
                        ></i>
                      </button>
                    </PopoverTrigger>
                    <DropdownCheckbox
                      options={volIssOptions}
                      selectedValues={selectedVolIssues}
                      onSelectionChange={handleVolIssueSelection}
                      selectAllText="All"
                      clearAllText="Clear all"
                      applyText="Apply"
                      searchPlaceholder="Search vol/iss..."
                      onClose={closeAllDropdowns}
                    />
                  </Popover> */}

                  <Popover
                    open={openDropdown === "handler"}
                    onOpenChange={(open) => {
                      if (open) {
                        toggleDropdown("handler");
                      } else {
                        closeAllDropdowns();
                        setProductionHandlersForFilter((prev) => [...prev]);
                      }
                    }}
                  >
                    <PopoverTrigger asChild>
                      <button
                        className={`flex items-center gap-1 px-3 py-1 h-[32px] rounded-md hover:bg-[#EFF1F1] ${
                          openDropdown === "handler" ? "bg-[#D9D9D9]" : ""
                        }`}
                      >
                        <span className="text-[#35424D] text-[13px]">
                          <span className="font-semibold">
                            Production handler:
                          </span>{" "}
                          <span className="font-medium">
                            {selectedProductionHandlers.includes("All")
                              ? "All"
                              : (() => {
                                  const firstSelected =
                                    productionHandlerOptions.find(
                                      (opt) =>
                                        opt.value ===
                                        selectedProductionHandlers[0]
                                    );
                                  return `${
                                    firstSelected
                                      ? firstSelected.label
                                      : selectedProductionHandlers[0]
                                  }${
                                    selectedProductionHandlers.length > 1
                                      ? " + more"
                                      : ""
                                  }`;
                                })()}
                          </span>
                        </span>
                        <i className="fas fa-chevron-down text-[#35424D] text-xs"></i>
                      </button>
                    </PopoverTrigger>
                    <DropdownCheckbox
                      options={productionHandlerOptions}
                      selectedValues={
                        selectedProductionHandlersId?.[0] === "All"
                          ? ["All"]
                          : selectedProductionHandlersId?.map(
                              (prod) => prod.value
                            )
                      }
                      onSelectionChange={handleProductionHandlerSelection}
                      selectAllText="All"
                      clearAllText="Clear all"
                      applyText="Apply"
                      isOpen={openDropdown}
                      searchPlaceholder="Search handlers..."
                      type="Journal"
                      label={true}
                      onClose={closeAllDropdowns}
                      SetSelectedValuesId={setSelectedProductionHandlersId}
                    />
                  </Popover>
                  {ArticleSections?.length > 0 && (
                    <Popover
                      open={openDropdown === "filter"}
                      onOpenChange={(open) => {
                        if (!open) {
                          closeAllDropdowns();
                          setArticleTypeOpen(false);
                          setProductionWorkflowOpen(false);
                          setPitOpen(false);
                          setDocHeadOpen(false);
                        } else {
                          toggleDropdown("filter");
                        }
                        if (open) {
                          setTempCopyediting(selectedCopyediting);
                          setTempPit(pit);
                          setTempDocHead(docHead);
                          setTempSceReturned(sceReturned);
                          setTempPressRelease(pressRelease);
                          setTempArticleS300Date(articleS300Date);
                          setTempCopyEditTaskComplete(copyEditTaskComplete);
                          setTempCfcTaskComplete(cfcTaskComplete);
                          setTempOnDate(onDate);
                          setTempCoverSubReceived(coverSubReceived);
                          setTempPreAcceptDate(preAcceptDate);
                          setTempsdPublishedOnWebS300(sdPublishedOnWebS300);
                        }
                      }}
                    >
                      <PopoverTrigger asChild>
                        <button
                          className={`flex items-center justify-center w-[32px] h-[32px] rounded-md ${
                            openDropdown === "filter"
                              ? "border-[#1C40C9] bg-[#B8C7FF] hover:bg-[#E1E6FF]"
                              : "hover:bg-[#E1E6FF]"
                          }`}
                        >
                          <div className="relative">
                            <MdOutlineFilterAlt className="text-[#1C40C9] h-[15px] w-[15px]" />
                            {hasFilters && (
                              <span className="absolute top-[-2px] right-[-2px] w-[6px] h-[6px] bg-red-500 rounded-full"></span>
                            )}
                          </div>
                        </button>
                      </PopoverTrigger>
                      <DynamicFilterPopover
                        sections={ArticleSections}
                        tempSelected={articleSelected}
                        setTempSelected={ArticleTempSetValues}
                        clearAllFilters={handleAdvancedClear}
                        applyFilters={applyFilters}
                        type="Article"
                        articleTypeOpen={articleTypeOpen}
                        setArticleTypeOpen={setArticleTypeOpen}
                        productionWorkflowOpen={productionWorkflowOpen}
                        setProductionWorkflowOpen={setProductionWorkflowOpen}
                        pitOpen={pitOpen}
                        setPitOpen={setPitOpen}
                        docHeadOpen={docHeadOpen}
                        setDocHeadOpen={setDocHeadOpen}
                        width="w-[350px]"
                        innerWidth="w-[318px]"
                      />
                    </Popover>
                  )}
                </div>
              </div>

              {(searchTerm.length >= 3 ||
                !selectedVolIssues.includes("All") ||
                selectedJournals !== null ||
                !selectedProductionHandlers.includes("All") ||
                !pit.includes("All") ||
                !docHead.includes("All") ||
                selectedArticleTypes.length > 0 ||
                sceReturned !== "" ||
                articleS300Date !== "" ||
                pressRelease !== "" ||
                copyEditTaskComplete !== "" ||
                cfcTaskComplete !== "" ||
                (onDate.from !== "" && onDate.to !== "") ||
                selectedCopyediting.length > 0) && (
                <div className="max-h-[300px] overflow-y-auto">
                  <FilterChips
                    filters={{
                      searchTerm: searchTerm.length >= 3 ? searchTerm : null,
                      volIss: !selectedVolIssues.includes("All")
                        ? selectedVolIssues
                        : null,
                      journals:
                        selectedJournals !== null ? [selectedJournals] : null,
                      "Production handler":
                        !selectedProductionHandlers.includes("All") &&
                        selectedProductionHandlers.length !==
                          productionHandlerOptions.length
                          ? selectedProductionHandlers
                          : null,
                      articleTypes:
                        selectedArticleTypes.length > 0
                          ? selectedArticleTypes
                          : null,
                      "Production workflow":
                        selectedCopyediting.length > 0
                          ? selectedCopyediting
                          : null,
                      PIT: !pit.includes("All") ? pit : null,
                      Dochead: !docHead.includes("All") ? docHead : null,
                      "SCE returned status":
                        sceReturned === true
                          ? "Yes"
                          : sceReturned === false
                          ? "No"
                          : null,
                      "Press release?":
                        pressRelease === true
                          ? "Yes"
                          : pressRelease === false
                          ? "No"
                          : null,
                      "Copy edit task complete":
                        copyEditTaskComplete === true
                          ? "Yes"
                          : copyEditTaskComplete === false
                          ? "No"
                          : null,
                      "CFC task complete":
                        cfcTaskComplete === true
                          ? "Yes"
                          : cfcTaskComplete === false
                          ? "No"
                          : null,
                      "Cover sub received":
                        coverSubReceived === true
                          ? "Yes"
                          : coverSubReceived === false
                          ? "No"
                          : null,
                      "Include pre accepteds":
                        preAcceptDate === true ? "Yes" : null,
                      "Include published articles":
                        sdPublishedOnWebS300 === true ? "Yes" : null,
                      articleS300:
                        articleS300Date === true
                          ? "Yes"
                          : articleS300Date === false
                          ? "No"
                          : null,
                      "ON date":
                        onDate.from !== "" && onDate.to !== ""
                          ? `${onDate.from} - ${onDate.to}`
                          : null,
                    }}
                    onRemoveFilter={(filterKey, value) => {
                        console.log("filterKey", filterKey, value)
                      switch (filterKey) {
                        case "searchTerm":
                          setSearchTerm("");
                          break;
                        case "volIss":
                          handleVolIssueSelection(
                            selectedVolIssues.filter((v) => v !== value)
                          );
                          break;
                        case "journals":
                          handleJournalSelection(null);
                          break;
                        case "Production handler":
                          handleProductionHandlerSelection(
                            selectedProductionHandlers.filter(
                              (h) => h !== value
                            ),
                            selectedProductionHandlersId.filter(
                              (h) => (typeof h === 'object' ? h.label : h) !== value
                            )
                          );
                          break;
                        case "articleTypes":
                          setSelectedArticleTypes(
                            selectedArticleTypes.filter((t) => t !== value)
                          );
                          break;
                        case "productionWorkflow":
                          const newCopyediting = selectedCopyediting.filter(
                            (c) => c !== value
                          );
                          setSelectedCopyediting(
                            newCopyediting.length > 0 ? newCopyediting : ["All"]
                          );
                          break;
                        case "pit":
                          const newPit = pit.filter((c) => c !== value);
                          setPit(newPit.length > 0 ? newPit : ["All"]);
                          break;
                        case "docHead":
                          const newDocHead = docHead.filter((c) => c !== value);
                          setDocHead(
                            newDocHead.length > 0 ? newDocHead : ["All"]
                          );
                          break;
                        case "SCEReturnedStatus":
                          setSceReturned("");
                          break;
                        case "pressRelease":
                          setPressRelease("");
                          break;
                        case "copyEditTask":
                          setCopyEditTaskComplete("");
                          break;
                        case "CFCTask":
                          setCfcTaskComplete("");
                          break;
                        case "coverSubReceived":
                          setCoverSubReceived("");
                          break;
                        case "preAcceptDate":
                          setPreAcceptDate(false);
                          break;
                        case "sdPublishedOnWebS300":
                          setSdPublishedOnWebS300(false);
                          break; 
                        case "articleS300":
                          setArticleS300Date("");
                          break;
                        case "onDate":
                          setOnDate({ from: "", to: "" });
                      }
                    }}
                    onClearAll={clearAllFilters}
                  />
                </div>
              )}
            </>
          </div>

          <div
            className={`overflow-y-auto ${
              articles.length > 0
                ? "border border-[#DCDCDC] rounded-md"
                : "flex flex-col h-full"
            } `}
          >
            {articles.length > 0 || searchTerm.trim() ? (
              <CustomTable
                data={articles}
                actions={action}
                searchTerm={searchTerm.trim()}
                setSearchTerm={setSearchTerm}
                setLoading={setIsLoading}
                headers={headers}
                setActiveRowId={setActiveRowId}
                activeRowId={activeRowId}
                rowSelectFunction={RowSelected}
                findEditable={findEditable}
                sortConfig={sortConfig}
                setSortConfig={setSortConfig}
                stickyJournal={false}
                stickyVolIss={false}
              />
            ) : (
              <div className="flex flex-col items-center w-full mt-10 h-3/4 justify-center">
                <img
                  src={NoData}
                  className="w-[72px] h-[75px]"
                  alt="No articles"
                />
                <h3 className="text-[#35424D] text-[27px] mb-6 font-semibold">
                  No Article Information at the moment.
                </h3>
                <button
                  className="text-[#1C40C9] text-[13px] h-[16px] font-semibold max-w-[200px]"
                  onClick={onBack}
                >
                  View Journal Overview
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

      {!showForm && articles.length > 0 && (
        <div className="mb-4">
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            totalItems={totalItems}
            itemsPerPage={itemsPerPage}
            onPageChange={handlePageChange}
            onItemsPerPageChange={handleItemsPerPageChange}
          />
        </div>
      )}

      {showForm && selectedArticle && (
        <Articleform
          text="Journal Overview"
          onback={onBack}
          initialData={selectedArticle}
          onCancel={() => {
            setShowForm(false);
            setActiveRowId(null);
          }}
          productionHandlers={productionHandlersForForm}
          fieldConfiguration={fieldConfiguration}
          type={true}
          onSave={HandleUpdateData}
        />
      )}

      {isModelOpen && selectedRow && (
        <PTSCard
          cancel={() => setIsModelOpen(false)}
          selectedRow={selectedRow}
          initialSelectedRow={initialSelectedRow}
          handleModalChange={handleChange}
          handleSaveChanges={HandleUpdateData}
          fieldConfiguration={fieldConfiguration}
          setSelectedRow={setSelectedRow}
          options={productionHandlersForForm}
          columnName={columnName}
          hasChanged={hasChanged}
          isEditable={userData?.articleOverview?.toLowerCase() === "edit"}
        />
      )}
    </div>
  );
};

export default Article;
